import { combineEpics } from 'redux-observable'
import {
  getCCPaymentsEpic,
  getCCUpcomingPaymentsEpic,
  deleteCCPaymentEpic,
  deleteCCAutoPaymentEpic,
  createCCAutoPaymentEpic,
  createCCPaymentEpic,
} from 'components/features/creditCard/creditCardStore/epics/ccPaymentsEpic'
import {
  patchCCOnboardingPropsEpic,
  patchCCOnboardingAddressEpic,
  patchCCOnboardingSSNEpic,
  patchCCOnboardingPropsSuccessEpic,
} from 'components/features/creditCard/creditCardStore/epics/ccOnboardingPatchEpic'
import { ccOnboardingInitiateEpic, ccOnboardingAcceptEpic, getCCOnboardingEpic, joinWaitlistEpic } from 'components/features/creditCard/creditCardStore/epics/ccOnboardingEpic'
import {
  getCCPaymentMethodsEpic,
  setCCPaymentMethodsEpic,
  createPaymentMethodEpic,
  deleteCCPaymentMethodEpic,
} from 'components/features/creditCard/creditCardStore/epics/ccPaymentMethodEpic'
import { createCCPhoneEpic, createCCPhoneFailEpic, verifyCCPhoneEpic, verifyCCPhoneFailEpic } from 'components/features/creditCard/creditCardStore/epics/ccOnboardingPhoneEpic'
import { ccStateEpic } from 'components/features/creditCard/creditCardStore/epics/ccStateEpic'
import { ccReplaceRequestEpic } from 'components/features/creditCard/creditCardStore/epics/ccReplaceRequestEpic'
import { ccLockEpic, ccUnlockEpic } from 'components/features/creditCard/creditCardStore/epics/ccLockEpic'
import { ccActivationEpic } from 'components/features/creditCard/creditCardStore/epics/ccActivationEpic'
import { ccShipmentAddressEpic } from 'components/features/creditCard/creditCardStore/epics/ccShipmentAddressEpic'

export const creditCardEpic = combineEpics(
  joinWaitlistEpic,
  ccActivationEpic,
  ccLockEpic,
  ccOnboardingAcceptEpic,
  ccOnboardingInitiateEpic,
  ccReplaceRequestEpic,
  ccStateEpic,
  ccUnlockEpic,
  createCCPhoneEpic,
  createCCPhoneFailEpic,
  createCCPaymentEpic,
  createCCAutoPaymentEpic,
  createPaymentMethodEpic,
  deleteCCAutoPaymentEpic,
  deleteCCPaymentEpic,
  deleteCCPaymentMethodEpic,
  getCCOnboardingEpic,
  getCCPaymentMethodsEpic,
  setCCPaymentMethodsEpic,
  getCCPaymentsEpic,
  getCCUpcomingPaymentsEpic,
  ccShipmentAddressEpic,
  patchCCOnboardingAddressEpic,
  patchCCOnboardingPropsEpic,
  patchCCOnboardingPropsSuccessEpic,
  patchCCOnboardingSSNEpic,
  verifyCCPhoneEpic,
  verifyCCPhoneFailEpic,
)
